// components/ShadowBoxTable.js

import React from 'react';

const ShadowBoxTable = ({ children }) => {
  const shadowBoxStyle = {
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    padding: '1rem',
    marginBottom: '1rem',
  };

  return <div style={shadowBoxStyle}>{children}</div>;
};

export default ShadowBoxTable;
